// NowCerts prospects as Quote History rows, for agencies with no MTM
// submissions. The agent's NowCerts token scopes the result to their agency.

export interface Prospect {
  insuredId?: string | null;
  name: string;
  dotNumber?: string | null;
  city?: string | null;
  state?: string | null;
  created?: string | null;
}

function apiBase(): string {
  return process.env.REACT_APP_TRUCKING_PORTAL_AI_API_Url ?? '';
}

function authHeaders(): Record<string, string> {
  return {
    Authorization: `Bearer ${localStorage.getItem('igtoken') || ''}`,
    'X-NC-Token': localStorage.getItem('NCToken') || '',
  };
}

export async function listProspects(): Promise<Prospect[]> {
  const res = await fetch(`${apiBase()}/ai/prospects`, { headers: authHeaders() });
  if (!res.ok) throw new Error(`Could not load prospects (${res.status}).`);
  const data = await res.json();
  return (data?.prospects as Prospect[]) ?? [];
}

export interface ProspectCount {
  drivers: number;
  vehicles: number;
}

/** Driver and vehicle counts per prospect. Fetched after the list renders,
 *  since each prospect costs two NowCerts calls. */
export async function listProspectCounts(
  insuredIds: string[],
): Promise<Record<string, ProspectCount>> {
  if (insuredIds.length === 0) return {};
  const res = await fetch(`${apiBase()}/ai/prospects/counts`, {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ insuredIds }),
  });
  if (!res.ok) throw new Error(`Could not load prospect counts (${res.status}).`);
  const data = await res.json();
  return (data?.counts as Record<string, ProspectCount>) ?? {};
}
